<template> 
    <div>

        <div>

            <div class="flex flex-wrap">

                <ul class="w-full flex justify-around mb-0 list-none flex-wrap pt-1 pb-2 flex-row">
                    <li class="-mb -px ms-1 me-2 last:mr-0 flex-auto text-center">
                        <a class="text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal"
                         v-on:click="callItemIsSelected(1)" v-bind:class="{'text-pink-600 bg-white': openedTab !== 1, 'text-white bg-blue-600': openedTab === 1}">
                        
                            {{$t(`menu.sessions`)}}
                        </a>
                    </li>

                    <li class="-mb-px me-2 last:mr-0 flex-auto text-center">
                        <a class="text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal"
                         v-on:click="callItemIsSelected(2)" v-bind:class="{'text-pink-600 bg-white': openedTab !== 2, 'text-white bg-blue-600': openedTab === 2}">
                            
                            {{$t(`menu.pitches`)}}

                        <!-- {{$t('menu.map')}} -->
                        </a>
                    </li>

                    <li class="-mb-px me-2 last:mr-0 flex-auto text-center">
                        <a class="text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal"
                         v-on:click="callItemIsSelected(3)" v-bind:class="{'text-pink-600 bg-white': openedTab !== 3, 'text-white bg-blue-600': openedTab === 3}">
                            
                            {{$t(`menu.memberships`)}}

                        </a>
                    </li>
                </ul>
            </div>
        </div>

        <div v-if="openedTab == 1">
                
                <public-info-sessions></public-info-sessions>
            </div>

             <div class="mt-5" v-if="openedTab == 2">
                
                <public-info-pitches></public-info-pitches>
            </div>


            <div class="mt-5" v-if="openedTab == 3">

                <public-info-all-memberships></public-info-all-memberships>
            </div>

            <!--
            <div class="mt-5">
                
                <public-info-gyms-memberships/>
            </div>

            <div class="mt-5">

                <public-info-ma-memberships/>

            </div>

            <div class="mt-5">

                <public-info-classes-memberships/>

            </div>

            <div class="mt-5">

                <public-info-studios-memberships/>
            </div> -->
    </div>
</template>

<script> 


import publicInfoSessions from './sessions/PublicInfoSessions.vue'

import publicInfoPitches from './pitches/PublicInfoPitches.vue';

import publicInfoAllMemberships from './Memberships/PublicInfoAllMemberships.vue';

// import publicInfoGymsMemberships from './Memberships/PublicInfoGymsMemberships.vue';

// import publicInfoMaMemberships from './Memberships/PublicInfoMaMemberships.vue';

// import publicInfoClassesMemberships from './Memberships/PublicInfoClassesMemberships.vue';

// import publicInfoStudiosMemberships from './Memberships/PublicInfoStudiosMemberships.vue';


    export default {

        mounted(){


        },

        components:{

            publicInfoSessions,
            publicInfoPitches,
            publicInfoAllMemberships            
            // publicInfoGymsMemberships,
            // publicInfoMaMemberships,
            // publicInfoClassesMemberships,
            // publicInfoStudiosMemberships            

        },

        methods:{

            callItemIsSelected(value){

                this.openedTab = value;
            }

        },

        data(){

            return{

                openedTab: 1,
            }
        }
     }
</script>

<style>

</style>
